import React from "react";
import { IMaskInput } from 'react-imask';

interface CustomProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
}

export const PhoneInputMask = React.forwardRef<HTMLInputElement, CustomProps>(
    function TextMaskCustom(props, ref) {
        const { onChange, ...other } = props;
        return (
            <IMaskInput
                {...other}
                mask="###-###-####"
                definitions={{
                    '#': /[0-9]/,
                }}
                inputRef={ref}
                onChange={(e) => {
                    // Don't remove dashes
                    const input = e.target as HTMLInputElement;
                    onChange({ target: { name: props.name, value: input.value } })
                }}
                onAccept={(value: any) => {
                    // Don't remove dashes
                    onChange({ target: { name: props.name, value: value } })
                }}
                overwrite
            />
        );
    },
);